import {client} from './services/client'

export  const notifications = {
    namespaced:true,
    state:{
        notifications:undefined,
        newnotifications:undefined,
    },
    mutations: {
        SET_NOTIFICATIONS (state,notifications){
            state.notifications = notifications
        },

        SET_NEWNOTIFICATIONS (state,notifications){
            state.newnotifications = notifications
        },

    },
    actions: {
        getNotifications({commit},data){
            return new Promise((resolve,reject)=>{
                let id=data.id;
                client({
                    method : 'post',
                    url:'/notifications/get/'+id,
                    data:data
                })
                    .then((response)=>{
                        let notifications = response.data.notifications;
                        commit('SET_NOTIFICATIONS',notifications);
                        commit('SET_NEWNOTIFICATIONS',[]);
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getNewNotifications({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/notifications/new/get/'+id,
                }).then((response)=>{
                        let notifications = response.data.notifications;
                        commit('SET_NEWNOTIFICATIONS',notifications);

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },


    },
    getters: {
        getReversements: state  => {
            return state.notifications
        },
    }
};
